import { Flex, Text } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { MouseEventHandler } from "react";

const HelperTextWithLink = ({
  text,
  to,
  linkTitle,
  onClickLink,
}: {
  text: string;
  to: string;
  linkTitle?: string;
  onClickLink?: MouseEventHandler<HTMLAnchorElement>;
}) => (
  <Flex direction="row" gap={8}>
    <Text c="var(--mantine-color-text-tertiary)">{text}</Text>
    {/* Callers pass runtime string paths, so bypass the typed `to`. */}
    <Link to={to as never} onClick={onClickLink}>
      <Text
        c="var(--mantine-color-text-tertiary)"
        style={{ textDecoration: "underline", cursor: "pointer" }}
      >
        {linkTitle || "Click here"}
      </Text>
    </Link>
  </Flex>
);

export default HelperTextWithLink;
